import {
  AvgAdjustmentByCarrierResponseSchema,
  OMSMetricsRequestSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAvgAdjustmentByCarrier = {
  name: "getAvgAdjustmentByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: AvgAdjustmentByCarrierResponseSchema,
};
